import createDragDropHandler from './drag-drop.util'
import './scene-content.component.less'

export default function sceneContentComponent (
  $log, $q, FileMediaService, ServiceAnnouncementsService,
  SocialMediaService, SceneCollectionService, SceneCollectionItemService, BulkApplyService, moment
) {
  'ngInject'
  return {
    restrict: 'E',
    scope: {},
    bindToController: {
      scene: '='
    },
    controller: () => { },
    controllerAs: 'ctrl',
    template: require('./scene-content.tpl.html').default,
    link: function ($scope, $element, attrs, ctrl) {
      ctrl.isCollapsed = false
      ctrl.playingSceneCollection = null
      ctrl.sceneCollections = []
      ctrl.isDeleting = false // Flag to track deletion in progress
      ctrl.showCalendar = false
      ctrl.showNewCollectionForm = false
      ctrl.newCollectionName = ''
      ctrl.editingCollectionId = null
      ctrl.editedCollectionName = ''
      // Calendar state management
      ctrl.closeCalendar = function () {
        ctrl.showCalendar = false
      }
      ctrl.showCreateButton = true

      ctrl.getSceneCollections = () => {
        return SceneCollectionService
          .getSceneCollectionsForScene(ctrl.scene.id)
          .then(sceneCollectionsResponse => {
            const sceneCollectionsPromises = sceneCollectionsResponse.map(sceneCollection => {
              sceneCollection.intervals = sceneCollection.intervals.map(interval => {
                interval.readable_begin = moment(interval.start_datetime).format('DD/MM HH:mm')
                interval.readable_end = moment(interval.end_datetime).format('DD/MM HH:mm')
                return interval
              })

              return sceneCollection
            })

            return $q.all(sceneCollectionsPromises)
          })
          .then(sceneCollections => {
            ctrl.sceneCollections = sceneCollections
            return SceneCollectionService.getActiveSceneCollectionId(ctrl.scene.id)
          })
          .then(sceneCollectionId => {
            ctrl.playingSceneCollection = sceneCollectionId
          })
          .catch(err => {
            $log.error(`[SceneContent] getSceneCollections: ${err.message}`, err)
          })
      }

      const sceneCollectionUnsubscribe = SceneCollectionService.subscribe(() => {
        ctrl.getSceneCollections()
      })

      ctrl.activeSceneCollection = null
      ctrl.activeSceneCollectionItems = []
      ctrl.setActiveSceneCollection = function setActiveSceneCollection (sceneCollectionId) {
        SceneCollectionItemService
          .getSceneCollectionItemsForSceneCollection(sceneCollectionId)
          .then(response => {
            ctrl.activeSceneCollectionItems = response.items
            const totalDuration = response.totalDuration
            return SceneCollectionService.get(sceneCollectionId).then(sceneCollection => {
              ctrl.activeSceneCollection = sceneCollection
              ctrl.activeSceneCollection.totalDuration = totalDuration
              SceneCollectionService.setActiveSceneCollection(sceneCollectionId)
            })
          }).catch(err => {
            $log.error(`[SceneContent] setActiveSceneCollection: ${err.message}`, err)
          })
      }

      const sceneCollectionItemUnsubscribe = SceneCollectionItemService.subscribe(state => {
        if (ctrl.activeSceneCollection) {
          ctrl.setActiveSceneCollection(ctrl.activeSceneCollection.id)
        }
      })

      ctrl.isIntervalActive = function (intervalEnd) {
        return new Date(intervalEnd) > new Date()
      }

      ctrl.getActiveIntervals = function (sceneCollection) {
        if (!sceneCollection.intervals || sceneCollection.intervals.length === 0) {
          return []
        }
        return sceneCollection.intervals.filter(interval => ctrl.isIntervalActive(interval.end_datetime))
      }

      ctrl.getIntervalsTooltip = function (sceneCollection) {
        const activeIntervals = ctrl.getActiveIntervals(sceneCollection)
        if (activeIntervals.length === 0) {
          return ''
        }
        const lines = activeIntervals.map(interval =>
          `${interval.readable_begin} til ${interval.readable_end}, prioritet ${interval.priority}`
        )
        return 'Planlagte intervaller:\n' + lines.join('\n')
      }

      ctrl.toggleIntervalTooltip = function (item) {
        // Close all other tooltips
        ctrl.sceneCollections.forEach(collection => {
          if (collection.id !== item.id) {
            collection.showIntervals = false
          }
        })
        // Toggle the clicked one
        item.showIntervals = !item.showIntervals
      }

      ctrl.removeActiveSceneCollection = function removeActiveSceneCollection () {
        ctrl.activeSceneCollection = null
        ctrl.activeSceneCollectionItems = []
        SceneCollectionService.removeActiveSceneCollection()
      }

      ctrl.orderUp = function orderSceneCollectionItemUp (sceneCollectionId, sceneCollectionItemId) {
        return SceneCollectionItemService
          .orderSceneCollectionItemUp(sceneCollectionId, sceneCollectionItemId)
          .catch(err => {
            $log.error(`❌ [SceneContent] orderUp failed: ${err.message}`, err)
          })
      }

      ctrl.orderDown = function orderSceneCollectionItemDown (sceneCollectionId, sceneCollectionItemId) {
        return SceneCollectionItemService
          .orderSceneCollectionItemDown(sceneCollectionId, sceneCollectionItemId)
          .catch(err => {
            $log.error(`❌ [SceneContent] orderDown failed: ${err.message}`, err)
          })
      }

      ctrl.deleteSceneCollection = function deleteSceneCollection (sceneCollectionId) {
        $log.info('🗑️ [SceneContent] User clicked delete button for SceneCollection (playlist) ID:', sceneCollectionId)

        if (ctrl.isDeleting) {
          return
        }

        if (confirm('Are you sure you want to delete the playlist?')) {
          ctrl.isDeleting = true
          SceneCollectionService
            .delete(sceneCollectionId)
            .catch(err => {
              $log.error(`❌ [SceneContent] deleteSceneCollection failed for ID ${sceneCollectionId}: ${err.message}`, err)
            })
            .finally(() => {
              ctrl.isDeleting = false
            })
        }
      }

      ctrl.editCollectionName = function editCollectionName (item) {
        ctrl.editingCollectionId = item.id
        ctrl.editedCollectionName = item.name
      }

      ctrl.saveCollectionName = function saveCollectionName (item) {
        if (!ctrl.editedCollectionName || !ctrl.editedCollectionName.trim()) {
          return
        }

        const name = ctrl.editedCollectionName.trim()
        SceneCollectionService.update({ id: item.id, name })
          .then(() => {
            ctrl.editingCollectionId = null
            ctrl.editedCollectionName = ''
          })
          .catch(err => {
            $log.error(`❌ [SceneContent] saveCollectionName failed: ${err.message}`, err)
          })
      }

      ctrl.cancelEditCollectionName = function cancelEditCollectionName () {
        ctrl.editingCollectionId = null
        ctrl.editedCollectionName = ''
      }

      ctrl.createNewSceneCollection = function createNewSceneCollection () {
        ctrl.showNewCollectionForm = true
        ctrl.showCreateButton = false
        ctrl.newCollectionName = ''
      }

      ctrl.saveNewSceneCollection = function saveNewSceneCollection () {
        if (ctrl.newCollectionName && ctrl.newCollectionName.trim()) {
          SceneCollectionService.create({
            name: ctrl.newCollectionName.trim()
          }).then(sceneCollection => {
            return SceneCollectionService.addSceneCollectionToScene(ctrl.scene.id, sceneCollection.id)
          }).then(() => {
            ctrl.showNewCollectionForm = false
            ctrl.newCollectionName = ''
            ctrl.showCreateButton = true
            // The subscription will update the list
          }).catch(err => {
            $log.error(`❌ [SceneContent] saveNewSceneCollection failed: ${err.message}`, err)
          })
        }
      }

      ctrl.cancelNewSceneCollection = function cancelNewSceneCollection () {
        ctrl.showNewCollectionForm = false
        ctrl.newCollectionName = ''
        ctrl.showCreateButton = true
      }

      ctrl.deleteSceneCollectionItem = function (id) {
        $log.info('🗑️ [SceneContent] User clicked delete button for SceneCollectionItem ID:', id)

        if (ctrl.isDeleting) {
          return Promise.resolve()
        }

        // Optimistic update - remove item immediately from UI
        ctrl.activeSceneCollectionItems = ctrl.activeSceneCollectionItems.filter(item => item.id !== id)

        ctrl.isDeleting = true
        return SceneCollectionItemService.delete(id)
          .catch(err => {
            $log.error(`❌ [SceneContent] Delete failed for ID ${id}, item will be restored via WebSocket: ${err.message}`, err)
            // Don't manually restore - let WebSocket subscription handle it
          })
          .finally(() => {
            ctrl.isDeleting = false
          })
      }

      // Add a property to store the copiedSceneCollectionId
      ctrl.copiedSceneCollectionId = SceneCollectionItemService.getCopiedSceneCollectionId()

      // Function to update copiedSceneCollectionId from the service
      ctrl.updateCopiedSceneCollectionId = function () {
        ctrl.copiedSceneCollectionId = SceneCollectionItemService.getCopiedSceneCollectionId()
      }

      // Watch for changes in the service and update the controller property
      $scope.$watch(function () {
        return SceneCollectionItemService.getCopiedSceneCollectionId()
      }, function (newVal, oldVal) {
        if (newVal !== oldVal) {
          ctrl.updateCopiedSceneCollectionId()
        }
      })

      // Function to store the ID of the SceneCollection to be copied
      ctrl.copySceneCollection = function (sceneCollectionId) {
        SceneCollectionItemService.setCopiedSceneCollectionId(sceneCollectionId)
        $log.info('Copied SceneCollection ID:', sceneCollectionId)
      }

      // Function to paste the copied SceneCollectionItems into another SceneCollection
      ctrl.pasteSceneCollectionItems = function (targetSceneCollectionId) {
        const sourceSceneCollectionId = SceneCollectionItemService.getCopiedSceneCollectionId()
        $log.info('Pasting SceneCollectionItems from:', sourceSceneCollectionId, 'to:', targetSceneCollectionId)
        if (!sourceSceneCollectionId || !targetSceneCollectionId) {
          $log.error('Both source and target SceneCollection IDs are required.')
          return
        }

        SceneCollectionItemService
          .copyItemsToSceneCollection(sourceSceneCollectionId, targetSceneCollectionId)
          .then(() => {
            $log.info('SceneCollectionItems pasted successfully.')
            // Clear copy buffer after successful paste
            SceneCollectionItemService.clearCopiedSceneCollectionId()
          })
          .catch(err => {
            $log.error(`[SceneContent] pasteSceneCollectionItems: ${err.message}`, err)
          })
      }

      // Function to delete all items in the active playlist
      ctrl.deleteAllSceneCollectionItems = function () {
        const itemCount = ctrl.activeSceneCollectionItems.length

        if (itemCount === 0) {
          $log.info('No items to delete in playlist')
          return
        }

        if (confirm(`Er du sikker på at du vil slette alle ${itemCount} elementer fra denne playliste? Denne handling kan ikke fortrydes.`)) {
          ctrl.isDeleting = true

          $log.info('🗑️ [SceneContent] User confirmed deletion of all items in playlist:', ctrl.activeSceneCollection.id)

          // No optimistic update - wait for WebSocket response
          SceneCollectionItemService
            .deleteAllItemsInPlaylist(ctrl.activeSceneCollection.id)
            .then(result => {
              $log.info(`✅ [SceneContent] Successfully deleted ${result.deletedCount} items from playlist`)
              // Clear copy buffer since copied items may have been deleted
              SceneCollectionItemService.clearCopiedSceneCollectionId()
              $log.info('Copy buffer cleared after delete all operation')
              // UI will update automatically via WebSocket subscription
            })
            .catch(err => {
              $log.error(`❌ [SceneContent] deleteAllSceneCollectionItems failed: ${err.message}`, err)
            })
            .finally(() => {
              ctrl.isDeleting = false
            })
        }
      }

      ctrl.durationIsEditable = function (sceneCollectionItem) {
        if (sceneCollectionItem.mediaType === 'file' && FileMediaService.getType(sceneCollectionItem.mediaId) === 'video') {
          // Disallow editing duration of FileMedia videos
          return false
        }

        return true
      }

      ctrl.validateAndSetDuration = function (id, duration) {
        let n = Math.floor(Number(duration))
        if (n > 0) {
          // Length is limited to 60 seconds (to ensure SM doesn't generate too long a queue in fillQueue)
          n = Math.min(n, 60)
          const newDuration = n * 1000
          return SceneCollectionItemService
            .update({
              id,
              duration: newDuration
            })
            .then(function () {
              return false
            })
            .catch(function (error) {
              $log.error(`Could not set duration for ${id}: `, error)
              return 'Error ' + error
            })
        }

        return 'Not a positive number.'
      }

      ctrl.playNow = function playNow (sceneCollectionId) {
        if (confirm('Are you sure you want to play this now?')) SceneCollectionService.playNow(sceneCollectionId)
      }

      // === Drag & Drop for SceneCollections (playlists) ===
      ctrl.collectionPlaceholderIndex = null

      ctrl.reorderSceneCollections = function (sourceCollectionId, targetCollectionId) {
        const sourceIndex = ctrl.sceneCollections.findIndex(item => item.id === sourceCollectionId)
        const targetIndex = ctrl.sceneCollections.findIndex(item => item.id === targetCollectionId)

        if (sourceIndex < 0 || targetIndex < 0) {
          $log.error('🔀 [SceneContent] Could not find source or target collection:', { sourceIndex, targetIndex })
          return
        }

        SceneCollectionService
          .reorderSceneCollections(ctrl.scene.id, sourceCollectionId, targetCollectionId)
          .catch(err => {
            $log.error(`❌ [SceneContent] reorderSceneCollections failed: ${err.message}`, err)
          })
      }

      // Simple drag handlers for the collection list (no auto-scroll needed — list is short)
      function handleCollectionDragStart (event) {
        const target = event.target.closest('[data-collection-id]')
        if (!target) return
        event.dataTransfer.setData('text/collection-id', target.getAttribute('data-collection-id'))
        event.dataTransfer.effectAllowed = 'move'
      }

      function handleCollectionDragOver (event) {
        // Only respond if this is a collection drag (not an item drag)
        if (!event.dataTransfer.types.includes('text/collection-id')) return
        event.preventDefault()

        const target = event.target.closest('[data-collection-position]')
        if (target) {
          const newIndex = parseInt(target.getAttribute('data-collection-position'))
          if (newIndex !== ctrl.collectionPlaceholderIndex) {
            ctrl.collectionPlaceholderIndex = newIndex
            $scope.$evalAsync()
          }
        }
      }

      function handleCollectionDrop (event) {
        const sourceIdStr = event.dataTransfer.getData('text/collection-id')
        if (!sourceIdStr) return
        event.preventDefault()

        const sourceId = parseInt(sourceIdStr)
        const target = event.target.closest('[data-collection-id]')

        if (target && sourceId) {
          const targetId = parseInt(target.getAttribute('data-collection-id'))
          if (targetId && targetId !== sourceId) {
            ctrl.reorderSceneCollections(sourceId, targetId)
          }
        }

        ctrl.collectionPlaceholderIndex = null
        $scope.$apply()
      }

      function handleCollectionDragEnd () {
        ctrl.collectionPlaceholderIndex = null
        $scope.$apply()
      }

      // Attach collection drag listeners to the collection list container
      const collectionListEl = $element[0]
      collectionListEl.addEventListener('dragstart', handleCollectionDragStart)
      collectionListEl.addEventListener('dragover', handleCollectionDragOver)
      collectionListEl.addEventListener('drop', handleCollectionDrop)
      collectionListEl.addEventListener('dragend', handleCollectionDragEnd)

      // === Drag & Drop for SceneCollectionItems (items within a playlist) ===
      ctrl.placeholderIndex = null

      ctrl.reorderItems = function (sourceItemId, targetItemId) {
        const sourceIndex = ctrl.activeSceneCollectionItems.findIndex(item => item.id === sourceItemId)
        const targetIndex = ctrl.activeSceneCollectionItems.findIndex(item => item.id === targetItemId)

        if (sourceIndex < 0 || targetIndex < 0) {
          $log.error('🔀 [SceneContent] Could not find source or target item:', { sourceIndex, targetIndex })
          return
        }

        SceneCollectionItemService
          .reorderSceneCollectionItems(ctrl.activeSceneCollection.id, sourceItemId, targetItemId)
          .catch(err => {
            $log.error(`❌ [SceneContent] reorderItems failed: ${err.message}`, err)
          })
      }

      // Create and initialize drag & drop handler for items within a playlist
      const dragDropHandler = createDragDropHandler({
        $scope,
        $element,
        $log,
        reorderItems: ctrl.reorderItems,
        setPlaceholderIndex: (index) => {
          ctrl.placeholderIndex = index
        }
      })

      dragDropHandler.initialize()

      // Be sure to unsubscribe and destroy any selections that have been made
      $scope.$on('$destroy', () => {
        // Clean up item drag & drop
        dragDropHandler.destroy()

        // Clean up collection drag & drop
        collectionListEl.removeEventListener('dragstart', handleCollectionDragStart)
        collectionListEl.removeEventListener('dragover', handleCollectionDragOver)
        collectionListEl.removeEventListener('drop', handleCollectionDrop)
        collectionListEl.removeEventListener('dragend', handleCollectionDragEnd)

        sceneCollectionUnsubscribe()
        sceneCollectionItemUnsubscribe()
        SceneCollectionService.removeActiveSceneCollection()
      })
    }
  }
}
